




export const Box_info=function(box,tasknum_,cur,end){
   this.box=box;
   this.tasknum_=tasknum_;
   this.cur=cur;
   this.end=end;
   
   


}








// WEBPACK FOOTER //
// ./src/components/xiayan/home/Box_info.js